import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { ContainerStyled, MultiplePaymentDetailStyled } from './styles'
import { NormalText, TitleStyled, TooltipStyled } from '../../shared/styles'
import { Button } from '../../shared/button/button'
import { Box, Icon, useTheme } from '@mui/material'
import { mockedTokensIcons } from '../mockedData'
import { DividerStyled } from '../../shared/divider/divider'
import { useEffect } from 'react'
import { getExcelMassivePaymentsStatus } from '../../redux/actions/transactions.actions'
import { Loader } from '../../shared/loader/loader'
import { useGetUser } from '../../hooks/useGetUser'
import { CheckCircle, Copy, XCircle } from '@phosphor-icons/react'
import html2pdf from 'html2pdf.js'

export const MultiplePaymentsDetail = () => {
  const {
    status: {
      data: dataMassivePaymentsExcelStatus,
      isLoading: isLoadingMassivePaymentsExcelStatus,
      error: errorMassivePaymentsExcelStatus,
    },
  } = useSelector((state) => state.transactions.massivePayments.excel)

  const { user } = useGetUser()
  const navigate = useNavigate()
  const { multiplePaymentsId } = useParams()
  const { palette } = useTheme()
  const dispatch = useDispatch()

  const multiplePaymentsDetail = dataMassivePaymentsExcelStatus?.data?.find(
    (payment) => payment.id === parseFloat(multiplePaymentsId)
  )
  const coin = multiplePaymentsDetail?.pagos?.[0]?.balance

  function copyToClipboard(text) {
    navigator.clipboard.writeText(text)
  }

  function handleDownloadPDF(paymentId) {
    const element = document.getElementById(`payment-detail-${paymentId}`)

    const pdfOnlyElements = element.querySelectorAll('.pdf-only')
    pdfOnlyElements.forEach((el) => (el.style.display = 'block'))

    const screenOnlyElements = element.querySelectorAll('.screen-only')
    screenOnlyElements.forEach((el) => (el.style.display = 'none'))

    const opt = {
      margin: 1,
      filename: `payment-${paymentId}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
    }

    html2pdf()
      .set(opt)
      .from(element)
      .save()
      .then(() => {
        pdfOnlyElements.forEach((el) => (el.style.display = 'none'))
        screenOnlyElements.forEach((el) => (el.style.display = ''))
      })
      .catch(() => {
        pdfOnlyElements.forEach((el) => (el.style.display = 'none'))
        screenOnlyElements.forEach((el) => (el.style.display = ''))
      })
  }

  useEffect(() => {
    if (!dataMassivePaymentsExcelStatus && user?.usuarioid) {
      dispatch(getExcelMassivePaymentsStatus(user?.usuarioid))
    }
  }, [dispatch, user, dataMassivePaymentsExcelStatus])

  if (errorMassivePaymentsExcelStatus) {
    return 'Error loading multiple payments detail'
  }

  if (isLoadingMassivePaymentsExcelStatus || !multiplePaymentsDetail) {
    return <Loader />
  }

  return (
    <ContainerStyled sx={{ flexDirection: 'row' }}>
      <Button
        startIcon={'CaretLeft'}
        onClick={() => navigate('/home')}
        type={'regular'}
        iconSize={14}
      />

      <Box display={'flex'} flexDirection={'column'} width={'100%'}>
        <TitleStyled sx={{ marginBottom: '8px' }}>
          Multiple payments detail
        </TitleStyled>
        <Box display={'flex'} flexDirection={'column'} gap={'8px'}>
          <Box display={'flex'} gap={'4px'} alignItems={'center'}>
            <NormalText isBold>ID:</NormalText>
            <NormalText>{multiplePaymentsDetail?.id}</NormalText>
          </Box>
          <Box display={'flex'} gap={'4px'} alignItems={'center'}>
            <NormalText isBold>Name:</NormalText>
            <NormalText>{multiplePaymentsDetail?.nombre_archivo}</NormalText>
          </Box>
          <Box display={'flex'} gap={'4px'} alignItems={'center'}>
            <NormalText isBold>Status:</NormalText>
            <NormalText>
              {multiplePaymentsDetail?.estado?.slice(0, 1).toUpperCase() +
                multiplePaymentsDetail?.estado?.slice(1)?.toLowerCase()}
            </NormalText>
          </Box>
          <Box display={'flex'} gap={'4px'} alignItems={'center'}>
            <NormalText isBold>Date:</NormalText>
            <NormalText>{multiplePaymentsDetail?.fecha_subida}</NormalText>
          </Box>
          <Box display={'flex'} gap={'4px'} alignItems={'center'}>
            <NormalText isBold>Total payments:</NormalText>
            <NormalText>{multiplePaymentsDetail?.total_pagos}</NormalText>
          </Box>
          <Box display={'flex'} gap={'4px'} alignItems={'center'}>
            <NormalText isBold>Total amount:</NormalText>
            <img
              src={
                mockedTokensIcons?.find((token) => token.name === coin)?.logo
              }
              alt={`${coin} icon`}
              style={{ width: '16px', height: '16px' }}
            />
            <NormalText>
              {multiplePaymentsDetail?.total_monto} {coin}
            </NormalText>
          </Box>
        </Box>
        <DividerStyled />
        <TitleStyled sx={{ marginBottom: '8px' }}>Payments</TitleStyled>
        <Box display={'flex'} flexDirection={'column'} gap={'8px'}>
          {multiplePaymentsDetail?.pagos?.map((payment) => (
            <MultiplePaymentDetailStyled
              key={payment.id}
              id={`payment-detail-${payment.id}`}
            >
              <Box className="pdf-only" display={'none'}>
                <Box
                  display={'flex'}
                  flexDirection={'column'}
                  gap={'8px'}
                  justifyContent={'center'}
                  alignItems={'center'}
                  mx={'auto'}
                >
                  <img src="/logo-tenui.png" alt="Logo Tenui" width={96} />
                  <NormalText color="#0f110c" size={16} isBold>
                    Transaction receipt
                  </NormalText>
                </Box>
              </Box>
              <Box className="pdf-only" display={'none'}>
                <DividerStyled />
              </Box>
              <Box display={'flex'} gap={'4px'} alignItems={'center'}>
                <NormalText isBold>Date:</NormalText>
                <NormalText>{payment.fecha_pago}</NormalText>
              </Box>
              <Box display={'flex'} gap={'4px'} alignItems={'center'}>
                <NormalText isBold>Amount:</NormalText>
                <img
                  className="screen-only"
                  src={
                    mockedTokensIcons?.find((token) => token.name === coin)
                      ?.logo
                  }
                  alt={`${coin} icon`}
                  style={{ width: '16px', height: '16px' }}
                />
                <NormalText>
                  {payment.monto_pagar} {coin}
                </NormalText>
              </Box>
              <Box display={'flex'} gap={'4px'} alignItems={'center'}>
                <NormalText isBold>Network:</NormalText>
                <NormalText>{payment.red}</NormalText>
              </Box>
              <Box display={'flex'} gap={'4px'} alignItems={'center'}>
                <NormalText isBold>Mail:</NormalText>
                <NormalText>{payment.mail}</NormalText>
              </Box>
              <Box display={'flex'} gap={'4px'} alignItems={'center'}>
                <NormalText isBold>Address:</NormalText>
                <NormalText>{payment.numero_cuenta}</NormalText>
                <TooltipStyled title="Copy" placement="top">
                  <Copy
                    sx={{
                      cursor: 'pointer !important',
                      fill: palette.grey[2],
                    }}
                    size={16}
                    onClick={() => copyToClipboard(payment.numero_cuenta)}
                  />
                </TooltipStyled>
              </Box>
              <Box display={'flex'} gap={'4px'} alignItems={'center'}>
                <NormalText isBold>Collaborator:</NormalText>
                <NormalText>{payment.colaborador}</NormalText>
              </Box>
              <Box display={'flex'} gap={'4px'} alignItems={'center'}>
                <NormalText isBold>Payment method:</NormalText>
                <NormalText>{payment.forma_pago}</NormalText>
              </Box>
              <Box display={'flex'} gap={'4px'} alignItems={'center'}>
                <NormalText isBold>Payment ID:</NormalText>
                <NormalText>{payment.id_pago}</NormalText>
              </Box>
              <Box display={'flex'} gap={'4px'} alignItems={'center'}>
                <NormalText isBold>ID:</NormalText>
                <NormalText>{payment.id}</NormalText>
              </Box>
              <Box
                sx={{
                  backgroundColor: palette.grey[3],
                  padding: '8px',
                  borderRadius: '8px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '4px',
                  mt: '8px',
                }}
              >
                <Box display={'flex'} gap={'4px'} alignItems={'center'}>
                  {payment.estado === 'COMPLETED' ||
                  payment.estado === 'CREATED' ? (
                    <CheckCircle
                      size={16}
                      weight="fill"
                      color={palette.primary[1]}
                    />
                  ) : (
                    <XCircle
                      size={16}
                      weight="fill"
                      color={palette.primary[2]}
                    />
                  )}
                  <NormalText isBold>{payment.estado}</NormalText>
                </Box>
                <NormalText
                  color={payment.estado === 'FAILED' && palette.primary[2]}
                >
                  {payment.transaccion_concepto}
                </NormalText>
              </Box>
              <Button
                className="screen-only"
                label={'Download receipt'}
                onClick={() => handleDownloadPDF(payment.id)}
                type={'regular'}
                startIcon={'Download'}
                containerStyles={{ marginTop: '8px' }}
              />
              <Box className="pdf-only" mb={'8px'} display={'none'}>
                <DividerStyled />
                <Box display={'flex'} justifyContent={'center'} gap={'8px'}>
                  <NormalText color="#0f110c" size={12}>
                    Thank you for using our portal.
                  </NormalText>
                </Box>
              </Box>
            </MultiplePaymentDetailStyled>
          ))}
        </Box>
      </Box>
    </ContainerStyled>
  )
}
